// extracted by mini-css-extract-plugin
export default {"grid":"HistoryDualImages_grid__tVjdR","cell":"HistoryDualImages_cell__aDLHL","elevated":"HistoryDualImages_elevated__lqtM2","image":"HistoryDualImages_image__UYf0v"};